module.exports = __webpack_public_path__ + "media/images/icons/map-pin-d8425b1b92be49079e015d28ffe49e9c.svg";